import React, { Component } from 'react';
import { Label, Input } from 'reactstrap';
import { Link } from 'react-router-dom';

class CheckboxCustom extends Component {
  static defaultProps = {
    classInput: 'checkboxes-itm__input',
    classLabel: 'checkboxes-itm__label',
  };

  render() {
    const {
      labelText,
      classLabel,
      classInput,
      labelLink,
      labelLinkRoutes,
      labelLinkOnClick,
      value,
      onClickHandler,
      onChange,
      name,
      id,
      checked,
    } = this.props;

    return (
      <div className="checkboxes-itm">
        <Label for={id} className={classLabel}>
          <Input
            type="checkbox"
            value={value}
            checked={checked}
            className={classInput}
            name={name}
            onChange={onChange}
            onClick={onClickHandler}
            id={id}
          />
          <div className="checkboxes-itm__svg">
            <svg
              width="22"
              height="22"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <rect width="28" height="28" />
              <path
                d="M0 7.77778L6.22222 14L18.6667 0"
                transform="translate(4.81068 7.76627)"
              />
            </svg>
          </div>
          <span className="checkboxes-itm__text">
            {labelText}{' '}
            {labelLink && (
              <Link to={labelLinkRoutes} onClick={labelLinkOnClick}>
                {labelLink}
              </Link>
            )}
          </span>
        </Label>
      </div>
    );
  }
}

export default CheckboxCustom;



// WEBPACK FOOTER //
// ./src/components/CheckboxCustom/CheckboxCustom.js